import { render, staticRenderFns } from "./DonorProfile.vue?vue&type=template&id=f531c6bc&"
import script from "./DonorProfile.vue?vue&type=script&lang=ts&"
export * from "./DonorProfile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports